import { 
   GET_COLECCION_CONCEPTO_CUENTA_CONTABLE,
   GET_COLECCION_LIGERA_CONCEPTO_CUENTA_CONTABLE,
   SHOW_CONCEPTO_CUENTA_CONTABLE,
   UPDATE_CONCEPTO_CUENTA_CONTABLE,
   DELETE_CONCEPTO_CUENTA_CONTABLE,
   CREATE_CONCEPTO_CUENTA_CONTABLE,
} from '../../shared/constants/ActionTypes';

const initialState = { 
   rows: [],
   ligera: [],
   selectedRow: null,
   desde: 1,
   hasta: 1,
   por_pagina: 1,
   pagina_actual: 1,
   ultima_pagina: 1,
   total: 1,
};

const ConceptoCuentaContableReducer = (state = initialState, action) => 
{
  switch (action.type) {
    case GET_COLECCION_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         rows: action.payload.data.datos, 
         desde: action.payload.data.desde, 
         hasta: action.payload.data.hasta, 
         por_pagina: action.payload.data.por_pagina, 
         pagina_actual: action.payload.data.pagina_actual, 
         ultima_pagina: action.payload.data.ultima_pagina, 
         total: action.payload.data.total, 
      };
    case GET_COLECCION_LIGERA_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         ligera: action.payload.data, 
      };
    case SHOW_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         selectedRow: action.payload, 
      };
    case UPDATE_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         selectedRow: action.payload.datos, 
      };
    case DELETE_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         selectedRow: action.payload.datos, 
      };
    case CREATE_CONCEPTO_CUENTA_CONTABLE: 
      return { 
         ...state, 
         selectedRow: action.payload.datos, 
      };
    default: 
      return state;
  }
};

export default ConceptoCuentaContableReducer;
